import * as mock from './mock-api';
import * as real from './real-api';

const MOCK_API = false;

export default (MOCK_API ? mock : real);
